import style from '../style/button.module.css'

export default function Button({title,click}){
    return(
        <button
         className={style.button}
         onClick={click}>
            {title}
        </button>
    )
}